import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TNotResident } from './models';

export const NotResident: FC<TNotResident> = ({
    Button,
    Text,
    className,
    isMobile,
    isNewDesign,
    isResident,
    notResident,
    showFormOuterWrapper = true,
    styles,
}) => {
    if (isResident === 'resident' || !notResident) return null;

    return (
        <div
            className={cn(
                {
                    [styles.notResidentBlock]: !isMobile && showFormOuterWrapper,
                },
                className
            )}
            data-test-id="non-resident"
        >
            <Text fontPreset="primaryNormal" styler={{ marginBottom: 24, marginTop: 0 }}>
                {notResident?.text}
            </Text>
            <Button
                block={isMobile || !isNewDesign}
                borderRadius={8}
                dataTestId="not-resident-link"
                hasAnimation
                href={notResident?.buttonLink}
                size="s"
                view="primary"
            >
                {notResident?.buttonText}
            </Button>
        </div>
    );
};
